import { DataGrid, ruRU, GridRowSelectionModel } from "@mui/x-data-grid";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import {
  repairsData,
  repairsDataDelete,
  repairsDataUpdate,
  repairsDataPage,
} from "src/features/repairs/repairsActions";

import { useDispatch } from "react-redux";

import React, { useState, useEffect, useContext } from "react";

import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

import { useNavigate } from "react-router-dom";

import { useAppSelector } from "../../hooks";

const theme = createTheme();

theme.typography.h10 = {
  fontSize: "0.9em",
  fontWeight: "700",
};

theme.typography.h6 = {
  fontSize: "0.7em",
};

export function RepairsTablePagination({ childToParent }) {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { dataRepairsPage } = useAppSelector((state) => state.repairsPage);

  const [disabledButton, setDisabledButton] = React.useState(false);

  const [selectedRows, setSelectedRows] = React.useState([]);

  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 3,
  });

  const { pageInfo, setPageInfo } = {
    totalRowCount: dataRepairsPage?.payload?.count,
  };

  // Some API clients return undefined while loading
  // Following lines are here to prevent `rowCountState` from being undefined during the loading
  const [rowCountState, setRowCountState] = React.useState(
    pageInfo?.totalRowCount || 0
  );
  React.useEffect(() => {
    setRowCountState((prevRowCountState) =>
      pageInfo?.totalRowCount !== undefined
        ? pageInfo?.totalRowCount
        : prevRowCountState
    );
  }, [pageInfo?.totalRowCount, setRowCountState]);

  useEffect(() => {
    dispatch(
      repairsDataPage([paginationModel.page, paginationModel.pageSize])
    ).then(() => {
      setRowCountState({ totalRowCount: dataRepairsPage?.payload?.count });
    });
  }, [
    repairsDataPage?.payload?.count,
    dispatch,
    paginationModel.page,
    paginationModel.pageSize,
  ]);

  /*
appearance:{time_arrival: '2023-10-25 10:55', time_departure: '2023-10-25 19:45', station: 'Москва-Киевская'}
client:null
client_contacts:[]
complete_date:null
executor:null
external_num:null
id:14
num:null
problems:null
request_date:"2023-10-27"
request_type:null
result:null
route:null
route_number:null
staff_wagon_number:null
wagon_build_date:null
wagon_contacts:[]
wagon_number:null
wagon_type:null
*/

  const columns = [
    { field: "id", headerName: "ID", width: 10 },

    {
      field: "appearance",
      headerName: "Параметры",
      width: 170,

      renderCell: (params) => (
        <div>
          <ThemeProvider theme={theme}>
            <Typography variant="h10">{"Время отправления:"}</Typography>
            <Typography variant="h6" color="textSecondary">
              {params.row.appearance.time_arrival}
            </Typography>

            <Typography variant="h10">{"Станция отправления:"}</Typography>
            <Typography variant="h6" color="textSecondary">
              {params.row.appearance.station}
            </Typography>

            <Typography variant="h10">{"Время прибытия:"}</Typography>
            <Typography variant="h6" color="textSecondary">
              {params.row.appearance.time_departure}
            </Typography>
          </ThemeProvider>
        </div>
      ),
    },

    {
      field: "client",
      headerName: "Клиент",
      width: 120,

      renderCell: (params) => (
        <div>
          <ThemeProvider theme={theme}>
            <Typography variant="h10" color="textSecondary">
              {params.row.client?.title}
            </Typography>
          </ThemeProvider>
        </div>
      ),
    },
    {
      field: "client_contacts",
      headerName: "Контакты",
      width: 220,

      renderCell: (params) => (
        <div>
          <ThemeProvider theme={theme}>
            {params.row.client_contacts && params.row.client_contacts.length ? (
              params.row.client_contacts?.map((contact, i) => (
                // console.log(contact),
                <div key={"client_contacts " + contact.id + " " + i}>
                  <Typography variant="h10" color="textSecondary">
                    {contact.name}
                  </Typography>
                  <br></br>
                  <Typography variant="h10" color="textSecondary">
                    {contact.position}
                  </Typography>

                  {contact.phones.map((phone, j) => (
                    // console.log(phone),
                    <div
                      key={
                        "client_contacts " + contact.id + " " + phone + " " + j
                      }
                    >
                      <Typography variant="h10" color="textSecondary">
                        {phone}
                      </Typography>
                    </div>
                  ))}
                  {contact.emails.map((email, k) => (
                    //  console.log(email),
                    <div
                      key={
                        "client_contacts " + contact.id + " " + email + " " + k
                      }
                    >
                      <Typography variant="h10" color="textSecondary">
                        {email}
                      </Typography>
                    </div>
                  ))}
                </div>
              ))
            ) : (
              <></>
            )}
          </ThemeProvider>
        </div>
      ),
    },
    { field: "executor", headerName: "Исполнитель", width: 160 },
    {
      field: "external_num",
      headerName: "Внешн. номер",
      width: 160,
      editable: true,
    },
    { field: "num", headerName: "Номер", width: 100, editable: true },

    { field: "problems", headerName: "Проблемы", width: 200, editable: true },
    {
      field: "request_date",
      headerName: "Дата запроса",
      width: 130,
      editable: true,
    },
    {
      field: "request_type",
      headerName: "Тип запроса",
      width: 160,
      renderCell: (params) => (
        <div>
          <ThemeProvider theme={theme}>
            <Typography variant="h10">{"Тип:"}</Typography>
            <Typography variant="h6" color="textSecondary">
              {params.row.request_type?.title}
            </Typography>

            <Typography variant="h10">{"Код проекта:"}</Typography>
            <Typography variant="h6" color="textSecondary">
              {params.row.request_type?.project_code}
            </Typography>
          </ThemeProvider>
        </div>
      ),
    },
    {
      field: "result",
      headerName: "Результат",
      width: 200,

      renderCell: (params) => (
        <div>
          <ThemeProvider theme={theme}>
            <Typography variant="h10">{"Сделано?:"}</Typography>
            <Typography variant="h6" color="textSecondary">
              {params.row.result?.done}
            </Typography>

            <Typography variant="h10">{"Описание:"}</Typography>
            <Typography variant="h6" color="textSecondary">
              {params.row.result?.description}
            </Typography>

            <Typography variant="h10">{"Проблемы:"}</Typography>
            <Typography variant="h6" color="textSecondary">
              {params.row.result?.problems}
            </Typography>
          </ThemeProvider>
        </div>
      ),
    },
    { field: "route", headerName: "Маршрут", width: 160, editable: true },

    {
      field: "route_number",
      headerName: "Номер маршрута",
      width: 160,
      editable: true,
    },
    {
      field: "staff_wagon_number",
      headerName: "Номер штаба",
      width: 160,
      editable: true,
    },
    {
      field: "wagon_build_date",
      headerName: "Дата постройки",
      width: 160,
      editable: true,
    },
    {
      field: "wagon_contacts",
      headerName: "Контакты на вагоне",
      width: 200,

      renderCell: (params) => (
        <div>
          <ThemeProvider theme={theme}>
            {params.row.wagon_contacts && params.row.wagon_contacts.length ? (
              params.row.wagon_contacts?.map((contact, i) => (
                //  console.log(contact),
                <div key={"wagon_contacts " + contact.id + " " + i}>
                  <Typography variant="h10" color="textSecondary">
                    {contact.name}
                  </Typography>
                  <Typography variant="h10" color="textSecondary">
                    {contact.position}
                  </Typography>

                  {contact.phones.map((phone, j) => (
                    //  console.log(phone),
                    <div
                      key={
                        "wagon_contacts " + contact.id + " " + phone + " " + j
                      }
                    >
                      <Typography variant="h10" color="textSecondary">
                        {phone}
                      </Typography>
                    </div>
                  ))}
                  {contact.emails.map((email, k) => (
                    // console.log(email),
                    <div
                      key={
                        "wagon_contacts " + contact.id + " " + email + " " + k
                      }
                    >
                      <Typography variant="h10" color="textSecondary">
                        {email}
                      </Typography>
                    </div>
                  ))}
                </div>
              ))
            ) : (
              <></>
            )}
          </ThemeProvider>
        </div>
      ),
    },
    {
      field: "wagon_number",
      headerName: "Номер вагона",
      width: 160,
      editable: true,
    },
    {
      field: "wagon_type",
      headerName: "Тип вагона",
      width: 100,

      renderCell: (params) => (
        <div>
          <ThemeProvider theme={theme}>
            <Typography variant="h10" color="textSecondary">
              {params.row.wagon_type?.title}
            </Typography>
          </ThemeProvider>
        </div>
      ),
    },

    {
      field: "action",
      headerName: "Действия",
      width: 280,
      sortable: false,
      disableClickEventBubbling: true,

      renderCell: (params) => {
        const onClickEdit = (e) => {
          const currentRow = params.row;

          //return alert(JSON.stringify(currentRow.id, null, 4));

          navigate(`/request/${currentRow.id}`);

          //navigate(`create-requests/', {currentRow.id});
        };

        const onClickRemove = (e) => {
          const currentRow = params.row;
          //console.log(currentRow)
          setDisabledButton(true);

          if (params.row?.id) {
            dispatch(repairsDataDelete(currentRow)).then(() => {
              dispatch(repairsData());
              setDisabledButton(false);
            });
          }

          ///return alert(JSON.stringify(currentRow, null, 4));
        };

        return (
          <Stack direction="row" spacing={2}>
            <Button
              variant="outlined"
              color="warning"
              size="small"
              onClick={onClickEdit}
            >
              Редактировать
            </Button>
            <Button
              disabled={disabledButton}
              variant="outlined"
              color="error"
              size="small"
              onClick={onClickRemove}
            >
              Удалить
            </Button>
          </Stack>
        );
      },
    },
  ];

  const handleRowSelection = (e) => {
    setSelectedRows(e);
  };

  React.useEffect(() => {
    childToParent(selectedRows);
  }, [selectedRows]);

  const [snackbar, setSnackbar] = React.useState(null);

  const handleCloseSnackbar = () => setSnackbar(null);

  const handleProcessRowUpdateError = React.useCallback((error) => {
    //console.log("Error Insert" + error.message);
    setSnackbar({ children: error.message, severity: "error" });
  }, []);

  const processRowUpdate = React.useCallback(
    async (newRow) => {
      console.log(newRow);

      const response = await dispatch(repairsDataUpdate(newRow));
      setSnackbar({ children: "Данные обновлены !", severity: "success" });
      return response.payload; // return the new row containing the row id
    },
    [dispatch]
  );

  //dataRepairsPage

  const [sortModel, setSortModel] = React.useState([
    {
      field: "id",
      sort: "asc",
    },
  ]);

  return (
    <div
      style={{
        height: "auto",
        width: "auto",
        position: "relative",
        left: "0px",
        top: "0px",
        marginBottom: "30px",
      }}
    >
      <DataGrid
        localeText={ruRU.components.MuiDataGrid.defaultProps.localeText}
        getRowHeight={() => "auto"}
        rows={dataRepairsPage?.payload?.list ?? []}
        rowCount={dataRepairsPage?.payload?.count ?? 0}
        loading={dataRepairsPage?.loading}
        columns={columns}
        pageSizeOptions={[1, 3]}
        paginationModel={paginationModel}
        paginationMode="server"
        onPaginationModelChange={setPaginationModel}
        processRowUpdate={processRowUpdate}
        onProcessRowUpdateError={handleProcessRowUpdateError}
        sortModel={sortModel}
        onSortModelChange={(model) => setSortModel(model)}
        onRowSelectionModelChange={handleRowSelection}
      />

      {!!snackbar && (
        <Snackbar
          open
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          onClose={handleCloseSnackbar}
          autoHideDuration={1500}
        >
          <Alert {...snackbar} onClose={handleCloseSnackbar} />
        </Snackbar>
      )}
    </div>
  );
}
